<template>
    <!-- 加上导入花名册功能后，1：标题，两种改为三种，2：弹框大小，500改为740 -->
    <el-dialog title="您可以选择以下两种种方式添加员工" :visible.sync="guideDialogVisible" width="500px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-add-dialog">
        <div class="card-wrap">
            <div v-for="(item, index) in cardList" :key="index" :class="['card-item', 'card-item' + index]" @click="handleLinkTo(index)">
                <div class="card-item_title">
                    <span>{{ item.title }}</span>
                    <i class="el-icon-arrow-right"></i>
                </div>
                <p>
                    {{ item.content }}
                </p>
            </div>
        </div>
        <el-button class="custom-know-btn" @click="handleDialogClose">我已知晓</el-button>
    </el-dialog>
</template>
<script>
export default {
    props: {
        guideDialogVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            cardList: [
                // {
                //     title: "导入花名册",
                //     content:
                //         "适用于公司刚进入系统，可以上传包含员工信息的Excel 表格，批量完成信息录入",
                // },
                {
                    title: "邀请加入",
                    content:
                        "您可以将二维码或者链接分享给新员工/公司内部人员，邀请他们自行填写信息快速加入公司",
                },
                {
                    title: "新增员工",
                    content: "手动添加单个员工，适用于少量人员录入",
                },
            ],
        };
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:guideDialogVisible", false)
            this.$emit("handleClickChangeGuideStatus", 2)
        },
        handleLinkTo(index) {
            this.$emit("update:guideDialogVisible", false)
            if(index == 0) {
                this.$router.push({
                    name: "ImportRoster"
                })
            } else if(index == 1) {
                this.$emit("handleClickInvit")
            } else {
                this.$emit("handleClickAddMember")
            }
        }
    },
};
</script>
<style lang="scss">
.card-wrap {
    margin-top: 12px;
    display: flex;
    gap: 16px;

    .card-item {
        width: 220px;
        height: 152px;
        padding: 24px 16px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        transition: transform 1s;

        .card-item_title {
            height: 22px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 16px;

            span {
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 22px;
                color: $font-active-color;
            }

            .el-icon-arrow-right {
                width: 22px;
                height: 22px;
                border-radius: 50%;
                text-align: center;
                line-height: 22px;
                font-size: 12px;
                font-weight: 700;
            }
        }

        p {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
        }
        &:hover {
            box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.08);
        }
    }

    .card-item0 {
        background-image: url("https://download.hecoos.com/enlightv/2024-42/c7f7cbb15b6f983ab967aabfb662219e.png");

        .el-icon-arrow-right {
            background-color: rgba(41, 144, 255, 0.25);
            color: rgba(41, 144, 255, 1);
        }

        &:hover,
        &:active {
            transform: translateY(-2px);
            background-image: url('https://download.hecoos.com/enlightv/2024-42/e56f4c32f3fcf4498ea30f8d6fa82f8d.png');
        }

    }

    .card-item1 {
        background-image: url("https://download.hecoos.com/enlightv/2024-42/746532f17090b4d51bee78f7fc749618.png");

        .el-icon-arrow-right {
            background-color: rgba(240, 170, 50, 0.2);
            color: rgba(240, 170, 50, 1);
        }

        &:hover,
        &:active {
            transform: translateY(-2px);
            background-image: url("https://download.hecoos.com/enlightv/2024-42/20cef9909b1ced53de406fcf9de27523.png");
        }
    }

    .card-item2 {
        background-image: url("https://download.hecoos.com/enlightv/2024-42/f874ef7ed9826cdcac1836886b621235.png");

        .el-icon-arrow-right {
            background-color: rgba(90, 179, 51, 0.2);
            color: rgba(90, 179, 51, 1);
        }

        &:hover,
        &:active {
            transform: translateY(-2px);
            background-image: url("https://download.hecoos.com/enlightv/2024-42/1fb5b3966c27cc754a054088b5dbd521.png");
        }
    }
}

.custom-add-dialog {
    .el-dialog {
        height: 338px;
    }
}
.custom-know-btn {
    width: 208px;
    height: 32px;
    padding: 0;
    text-align: center;
    line-height: 32px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(41, 144, 255, 1);
    color: rgba(41, 144, 255, 1);
    font-size: 14px;
    font-weight: 400;
    margin-top: 38px;
    margin-left: 50%;
    transform: translateX(-50%);

    &:hover {
        background: rgba(255, 255, 255, 1);
        border-color: rgba(75, 162, 255, 1);
        color: rgba(75, 162, 255, 1);
    }

    &:active {
        background: rgba(255, 255, 255, 1);
        border-color: rgba(34, 121, 214, 1);
        color: rgba(34, 121, 214, 1);
    }

}
</style>
